import { createFileRoute } from '@tanstack/react-router';

import { getProceedingOptions } from '@/module/Author/Proceeding';

export const Route = createFileRoute('/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout')({
  loader: async ({ params: { proceedingId }, context: { queryClient } }) => {
    const proceeding = await queryClient.ensureQueryData(getProceedingOptions(proceedingId));

    return {
      proceeding,
      crumb: proceeding.title,
    };
  },
});
